/**
 * Quote numbering is configuration, not code. Changing the house style for
 * every business is a change to this object — nothing reads the parts directly.
 */
import { BRAND } from './brand';

export interface QuoteNumberFormat {
  prefix: string;
  /** Include the four-digit year segment: `QT-2026-000001`. */
  includeYear: boolean;
  /** Zero-padding width of the sequence segment. */
  padding: number;
  separator: string;
}

export const DEFAULT_QUOTE_NUMBER_FORMAT: QuoteNumberFormat = {
  prefix: BRAND.quotePrefix,
  includeYear: true,
  padding: 6,
  separator: '-',
};
